const JobDetailSection = ({ section }) => {
  const pairedContent = [];
  for (let i = 0; i < section.content.length; i += 2) {
    pairedContent.push({
      item1: section.content[i],
      item2: section.content[i + 1],
      isAlternateBackground: (i / 2) % 2 === 0, 
    });
  }

  const SectionItem = ({ item }) => {
    if (!item) return <div className="space-y-1"></div>; 

    return (
      <div className="space-y-1">
        <p className="text-sm mb-2 capitalize">
          {item.label} {item.required && <span className="text-destructive">*</span>}
        </p>
        {item.list && (
          <ul className="list-disc pl-5 space-y-1 text-sm font-semibold">
            {item.list.map((listItem, k) => (
              <li key={k} className="capitalize">{listItem}</li>
            ))}
          </ul>
        )}
        {item.tags && (
          <div className="text-sm font-semibold flex gap-3 flex-wrap">
            {item.tags.map((tag, k) => (
              <p
                key={k}
                className="bg-primary-900 rounded-[0.75rem] p-[0.5rem] text-white w-fit capitalize"
              >
                {tag}
              </p>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="mt-[2rem]">
      <div className="flex items-center gap-4 my-[1.5rem]">
        <section.Icon className="w-6 h-6" />
        <span className="text-md font-semibold">{section.title}</span>
      </div>

      <div className="space-y-4">
        {pairedContent.map((pair, index) => (
          <div
            key={index}
            className={`text-secondary grid grid-cols-2 items-start p-[0.75rem] rounded-[1rem] ${
              pair.isAlternateBackground ? "bg-sidebar" : ""
            }`}
          >
            <SectionItem item={pair.item1} />
            <SectionItem item={pair.item2} />
          </div>
        ))}
      </div>
    </div>
  );
};
export default JobDetailSection